export default "__VITE_ASSET__a9bcd18d__"